import { BookingType } from "../../../../features/Booking-Form/typings/booking-inputs";
import { BookingScheduleInterface } from "../../../../features/Booking-Form/typings/booking.types";
import { normalizePicturePaths } from "../../../BookingForm/functions/normalizePicturePaths.function";
import { VehicleInventory } from "../../../FleetManagement/types/VehicleInventory.types";

type FetchZoneInventory = (zoneInventoryId: number) => Promise<{
  picturePaths?: string[] | null;
}>;

type Args = {
  schedule?: BookingScheduleInterface;
  fetchZoneInventory: FetchZoneInventory;
  setTargetPictures: (picturePaths: string[]) => void;
};

export async function setPicturesFromSchedule({
  schedule,
  fetchZoneInventory,
  setTargetPictures
}: Args): Promise<void> {
  // currently, only conference room has pictures
  if (schedule?.bookingType === BookingType.CONFERENCEZONE) {
    try {
      const data = await fetchZoneInventory(schedule.bookingInventoryId);
      setTargetPictures(data.picturePaths ?? []);
    } catch {
      setTargetPictures([]);
    }
    return;
  }

  if (schedule?.bookingType === BookingType.VEHICLE) {
    const picturePaths =
      schedule?.vehicleInfo?.picturePaths ||
      (schedule?.bookingInventory as VehicleInventory)?.picturePaths;
    if (!picturePaths) {
      setTargetPictures([]);
      return;
    }
    const normPicturePaths = normalizePicturePaths(picturePaths);
    setTargetPictures(normPicturePaths ?? []);
    return;
  }

  // explicitly handle other booking types
  setTargetPictures([]);
}
